import { render, staticRenderFns } from "./IconLive.vue?vue&type=template&id=ca987bfc"
import script from "./IconLive.vue?vue&type=script&lang=js"
export * from "./IconLive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports